import React from 'react';
import { GraduationCap, BookOpen, Rocket, Check } from 'lucide-react';
import { addOnsData } from '../mock/programsData';

const cards = [
  { Icon: GraduationCap, accent: 'text-pink-600', border: 'border-pink-300', bg: 'from-pink-50 to-white', chip: 'from-pink-200 to-pink-300' },
  { Icon: BookOpen, accent: 'text-purple-600', border: 'border-purple-300', bg: 'from-purple-50 to-white', chip: 'from-purple-200 to-purple-300' },
  { Icon: Rocket, accent: 'text-blue-600', border: 'border-blue-300', bg: 'from-blue-50 to-white', chip: 'from-blue-200 to-blue-300' }
];

const AddOns = () => {
  return (
    <section
      id="add-ons"
      data-testid="addons-section"
      className="py-20 bg-gradient-to-br from-pink-50 via-yellow-50 to-purple-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-600 mb-4">
            {addOnsData.title}
          </h2>
          <p className="text-base md:text-lg text-purple-600 max-w-2xl mx-auto">
            {addOnsData.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {addOnsData.addOns.map((a, i) => {
            const { Icon, accent, border, bg, chip } = cards[i % cards.length];
            return (
              <div
                key={a.id}
                data-testid={`addon-${a.id}`}
                className={`bg-gradient-to-br ${bg} border-3 ${border} rounded-3xl p-7 hover:shadow-2xl transition-all duration-300 flex flex-col`}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${chip} rounded-2xl flex items-center justify-center mb-5`}>
                  <Icon className={`h-7 w-7 ${accent}`} />
                </div>
                <h3 className={`text-xl font-bold ${accent} mb-3`}>{a.name}</h3>
                <p className="text-sm text-gray-700 mb-5 leading-relaxed">
                  {a.description}
                </p>

                <p className="text-xs font-bold uppercase tracking-wider text-purple-700 mb-3">
                  May include
                </p>
                <ul className="space-y-2 mb-6 flex-1">
                  {a.includes.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                      <Check className={`h-4 w-4 ${accent} flex-shrink-0 mt-0.5`} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <div className={`mt-auto pt-4 border-t-2 ${border}`}>
                  <p className="text-xs text-gray-500 mb-1">Additional price</p>
                  <p className={`font-bold ${accent}`}>{a.price}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AddOns;
